import Vue from "vue";
import Router from "vue-router";

import moment from "moment";
import Store from "@/store";
import encryptation from "@/services/mixins/encryptation";
import { checkPermission } from "@/services/utils";

Vue.use(Router);

const Guest = {
  path: "/login",
  component: () => import("@/views/guest"),
  children: [
    {
      path: "",
      name: "login",
      meta: {
        guest: true
      },
      component: () => import("@/views/login")
    },
    {
      path: "/forgetPassword",
      name: "forgetPassword",
      meta: {
        guest: true
      },
      component: () => import("@/views/forgetPassword")
    },
    {
      path: "/password/reset",
      name: "resetPassword",
      meta: {
        guest: true
      },
      component: () => import("@/views/resetPassword")
    }
  ]
};

const Route = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    Guest,
    {
      path: "/gerar-relatorio/:uuid",
      name: "generate-pdf-quiz",
      meta: {
        guest: true
      },
      props: true,
      component: () => import("@/views/quiz/generatePdf")
    },
    
    {
      path: "/",
      component: () => import("@/views/dashboard"),
      children: [
        {
          path: "",
          name: "home",
          meta: {
            guest: false,
            name: "Panel"
          },
          component: () => import("@/views/panel")
        },
        {
          path: "/cliente",
          name: "customers",
          meta: {
            guest: false,
            name: "Clientes",
            module: "customer"
          },
          component: () => import("@/views/customer/list.vue")
        },
        {
          path: "/cliente/novo-cliente",
          name: "customer-create",
          meta: {
            guest: false,
            name: "Novo Cliente",
            module: "customer",
            permission: "create"
          },
          component: () => import("@/views/customer/createOrUpdate.vue")
        },
        {
          path: "/cliente/editar-cliente/:id",
          name: "customer-edit",
          meta: {
            guest: false,
            name: "Editar Cliente",
            module: "customer",
            permission: "edit"
          },
          props: true,
          component: () => import("@/views/customer/createOrUpdate.vue")
        },
        {
          path: "/usuarios",
          name: "users",
          meta: {
            guest: false,
            name: "Usuários",
            module: "user"
          },
          component: () => import("@/views/users/list.vue")
        },
        {
          path: "/usuarios/novo-usuario",
          name: "user-create",
          meta: {
            guest: false,
            name: "Novo Usuário",
            module: "user",
            permission: "create"
          },
          component: () => import("@/views/users/createOrUpdate.vue")
        },
        {
          path: "/usuarios/editar-usuario/:id",
          name: "user-edit",
          meta: {
            guest: false,
            name: "Editar Usuário",
            module: "user",
            permission: "edit"
          },
          props: true,
          component: () => import("@/views/users/createOrUpdate.vue")
        },
        {
          path: "/questoes",
          name: "questions",
          meta: {
            guest: false,
            name: "Questões",
            module: "question"
          },
          component: () => import("@/views/question/list.vue")
        },
        {
          path: "/questoes/nova-questao",
          name: "question-create",
          meta: {
            guest: false,
            name: "Nova Questão",
            module: "question",
            permission: "create"
          },
          component: () => import("@/views/question/createOrUpdate.vue")
        },
        {
          path: "/questoes/nova-questao/:id",
          name: "question-edit",
          meta: {
            guest: false,
            name: "Editar Questão",
            module: "question",
            permission: "edit"
          },
          props: true,
          component: () => import("@/views/question/createOrUpdate.vue")
        },
        {
          path: "/questionario",
          name: "quizzes",
          meta: {
            guest: false,
            name: "Questionários",
            module: "quiz"
          },
          component: () => import("@/views/quiz/list.vue")
        },
        {
          path: "/questionario/novo-questionario",
          name: "quiz-create",
          meta: {
            guest: false,
            name: "Novo Questionário",
            module: "quiz",
            permission: "create"
          },
          component: () => import("@/views/quiz/createOrUpdate.vue")
        },
        {
          path: "/questionario/editar-questionario/:id",
          name: "quiz-edit",
          meta: {
            guest: false,
            name: "Editar Questionário",
            module: "quiz",
            permission: "edit"
          },
          props: true,
          component: () => import("@/views/quiz/createOrUpdate.vue")
        },
        {
          path: "/questionario/exportar",
          name: "quiz-export",
          meta: {
            guest: false,
            name: "Exportar Questionário",
            module: "quiz",
            permission: "export"
          },
          props: true,
          component: () => import("@/views/quiz/Export.vue")
        },
        {
          path: "/relatorio-mobile/:uuid",
          name: "mobile-report",
          meta: {
            guest: false,
            name: "Relatório Mobile",
            module: "quiz"
          },
          props: true,
          component: () => import("@/views/quiz/mobileReport")
        }
      ]
    },
    {
      path: "/responder-questionario/:id",
      meta: {
        guest: true,
        name: "Responda Questionário",
        module: "quiz",
        permission: "apply"
      },
      name: "response-quiz",
      props: true,
      component: () => import("@/views/answers/createResp.vue")
    },
    {
      path: "/responder-externo/:id",
      meta: {
        guest: true,
        name: "Responda Questionário",
      },
      name: "response-externo",
      props: true,
      component: () => import("@/views/answers/createRespExterno.vue")
    },
    {
      path: "/responder-questionario/:id/responder",
      meta: {
        guest: true,
        module: "quiz",
        permission: "apply"
      },
      name: "responder-questionario",
      props: true,
      component: () => import("@/views/answers/Responder.vue")
    },
    {
      path: "/responder-questionario/:id/feedback",
      name: "feedback",
      meta: {
        guest: true,
        module: "quiz",
        permission: "apply"
      },
      component: () => import("@/views/answers/Feedback.vue"),
      props: true
    },
    {
      path: "/responder-externo/:id/responder",
      meta: {
        guest: true,
      },
      name: "responder-questionario-externo",
      props: true,
      component: () => import("@/views/answers/ResponderExterno.vue")
    },
    {
      path: "/responder-externo/:id/feedback",
      name: "feedback-externo",
      meta: {
        guest: true,
      },
      component: () => import("@/views/answers/FeedbackExterno.vue"),
      props: true
    },
    {
      path: "*",
      redirect: (to, from, next) => {
        next({ name: "login" });
      }
    }
  ]
});

Route.beforeEach(async (to, from, next) => {
  const cache = localStorage.getItem("cache");

  if (!to.meta.guest) {
    document.querySelector("body").style = "background: #e5e5e5;";
    if (cache) {
      const data = encryptation.methods.decrypt(cache.toString());
      if (moment(data.expiration) > moment()) {
        const { user, jwt } = data;
        Store.commit("User/updateUser", user);
        Store.commit("User/updateToken", jwt.access_token);

        const { role } = user;

        if (role == null || role.slug == "ADMIN") next();
        else {
          if (middlewarePermission(role, to)) next();
          else {
            next({
              name: from.name
            });

            return;
          }
        }
      } else {
        localStorage.clear();
        Store.commit("User/clearUser");
        localStorage.setItem("error-session", true);
        document.location.href = "/login";
      }
    } else {
      localStorage.setItem("error-session", true);
      document.location.href = "/login";
    }
  } else {
    document.querySelector("body").style = "background: #fff;";
    next();
  }
});

const middlewarePermission = (role, route) => {
  const module = route.meta.module;
  const permission = route.meta.permission;

  return checkPermission({ module, permission }, role);
};

export default Route;
